import { IPlanAdd } from '@shared/components';
import { create } from 'zustand';

export type ICrossSellerStateSelectedPlans = IPlanAdd;

interface ICrossSellerState {
  selectedPlans: ICrossSellerStateSelectedPlans[];
  companyId: string;
  setSelectedPlans: (
    CrossSellerState: ICrossSellerStateSelectedPlans[],
  ) => void;
}

export const useCrossSellerState = create<ICrossSellerState>(set => {
  return {
    selectedPlans: sessionStorage.getItem('selectedPlans')
      ? Object.values(JSON.parse(sessionStorage.getItem('selectedPlans')!))
      : [],
    companyId: sessionStorage.getItem('companyId') || '',
    setSelectedPlans(newSelectedPlans: ICrossSellerStateSelectedPlans[]) {
      set({ selectedPlans: newSelectedPlans });
      sessionStorage.setItem('selectedPlans', JSON.stringify(newSelectedPlans));
    },
  };
});
